import { render, staticRenderFns } from "./UserInfoInput.vue?vue&type=template&id=cdfcb954&"
import script from "./UserInfoInput.vue?vue&type=script&lang=js&"
export * from "./UserInfoInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\websites\\newshop\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cdfcb954')) {
      api.createRecord('cdfcb954', component.options)
    } else {
      api.reload('cdfcb954', component.options)
    }
    module.hot.accept("./UserInfoInput.vue?vue&type=template&id=cdfcb954&", function () {
      api.rerender('cdfcb954', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/UserInfoInput.vue"
export default component.exports